import { Units } from '../constants/units';
import * as angular from 'angular';
/// <reference types="angular" />

export default function Abbreviate(Units) {
  let abbv = {};
  abbv[Units.inches] = 'in';
  abbv[Units.feet] = 'ft';
  abbv[Units.gallons] = 'G';
  abbv[Units.liters] = 'L';
  abbv[Units.meters] = 'm';
  abbv[Units.ounces] = 'oz';
  abbv[Units.lbs] = 'lbs';
  abbv[Units.mA] = 'mA';

  return function(units: string): string {
    return abbv[units];
  };
}

angular.module('ciApp').factory('Abbreviate', ['Units', Abbreviate]);



// WEBPACK FOOTER //
// ./common/services/abbreviate.service.ts